import React from 'react';
import { TopPerformer } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';

interface TopPerformersCardProps {
    topPerformers: TopPerformer[];
}

const getInitials = (name: string): string =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');

const TopPerformersCard: React.FC<TopPerformersCardProps> = ({ topPerformers }) => (
    <DashboardCard title="Top Performers" className="ad-card-performers ad-col-performers">
        <ol className="ad-performers">
            {topPerformers.map((performer) => (
                <li key={performer.rank} className="ad-performer">
                    <span className="ad-performer-rank">{performer.rank}.</span>
                    <div className="ad-performer-avatar" title={`${performer.hoursSaved}h saved`}>
                        {performer.avatarUrl ? (
                            <img src={performer.avatarUrl} alt={performer.name} />
                        ) : (
                            <span>{getInitials(performer.name)}</span>
                        )}
                    </div>
                    <span className="ad-performer-name">{performer.name}</span>
                </li>
            ))}
        </ol>
    </DashboardCard>
);

export default TopPerformersCard;
